module.exports = __webpack_public_path__ + "static/media/1-4.49eb4315.mp3";